import React, { useState, useEffect, useRef } from "react";
import Grow from "@material-ui/core/Grow";
import Paper from "@material-ui/core/Paper";
import Popper from "@material-ui/core/Popper";
import { makeStyles } from "@material-ui/core/styles";

// import "./MultiselectList.scss";
import MultiSelectList from "./MultiSelectList";

import blueDownArrow from "../../images/gilead- collapse-dropdown.svg";
import grayDownArrow from "../../images/gilead-disabled-dropdown-arrow.svg";
import blueUpArrow from "../../images/gilead-expand-dropdown.svg";
import "./MultiselectDropDown.scss";
 import FooterButtons from "./FooterButtons"; 
import PrimaryButton from "./PrimaryButton";
import LinkButton from "./LinkButton";
import { ClickAwayListener } from "@material-ui/core";

const useStyles = makeStyles((theme) => ({
  root: {
    // zIndex: "9999",
    display: "inline-block",
  },
  paper: {
    marginRight: theme.spacing(2),
  },
}));

const MultiselectDropDown = ({
  title,
  data,
  applySelection,
  disabled = false,
  selectedFilterData,
  setIsSearchBarEmpty,
  values,
  multiple,
  setCreatePresentationFields,
  createPresentationFields,
  getSearchCriteria,
  searchExpand
}) => {
  const [isOpen, toggleisOpen] = useState(false);
  const [selectedData, setSelectedData] = useState({
    product: [],
    country: [],
    mlrStatus: [],
    indication: []
  });
  const classes = useStyles();
  const anchorRef = useRef(null);
  const [initialLoad, toggleInitialLoad] = useState(true);
  const [filteredList, setFilteredList] = useState([]);
  const [searchText, setSearchText] = useState("");

  const handleToggle = () => {
    toggleisOpen((prevOpen) => !prevOpen);
  };

  useEffect(() => {
    if(title === "Product") {
      setSelectedData({...selectedData, product: selectedFilterData});
    } else if (title === "Country") {
      setSelectedData({...selectedData, country: selectedFilterData});
    }
  }, [selectedFilterData]);

// console.log(selectedFilterData)
//   useEffect(() => {
//   setSelectedData(prev => ({
//     ...prev,
//     product: selectedFilterData
//   }));
// }, [selectedFilterData]);

  const handleClose = (event) => {
    toggleisOpen(false);
  };

  const handleSelection = (isChecked, element, title) => {
    if(title === "Country") {
      toggleInitialLoad(false);
      setSelectedData(prev => {
      const currentList = prev.country || [];
      const isSelected = currentList.some(i => i.name === element.name);

      const updatedList = isSelected
        ? currentList.filter(i => i.name !== element.name)
        : [...currentList, element];

      return {
        ...prev,
        country: updatedList,
      };
    });
      // console.log(selectedData, 'tttt')
      // let index = selectedData?.country?.findIndex((el) => el.id === element.id);
      // if (index === undefined) {
      //   index = -1;
      // }
      // if (isChecked && index === -1) {
      //   setSelectedData((oldData) => {
      //     if (oldData?.country) {
      //       oldData.country = oldData?.country?.concat(element);
      //     } else {
      //       oldData.country = element;
      //     }
      //     return oldData;
      //   });
      // } else if (!isChecked && index > -1) {
      //   setSelectedData((oldData) => {
      //     oldData.country = oldData?.country?.filter((el) => {
      //       return el.id !== element.id;
      //     });
      //     if (oldData?.country?.length === 0) {
      //       enableDisableApplyButton();
      //     }
      //     return oldData;
      //   });
      // }
    }
    if(title === "Product") {
      toggleInitialLoad(false);
      setSelectedData(prev => {
      const currentList = prev.product || [];
      const isSelected = currentList.some(i => i.name === element.name);

      const updatedList = isSelected
        ? currentList.filter(i => i.name !== element.name)
        : [...currentList, element];

      return {
        ...prev,
        product: updatedList,
      };
    });
      // console.log(selectedData, 'tttt')
      // let index = selectedData?.product?.findIndex((el) => el.id === element.id);
      // if (index === undefined) {
      //   index = -1;
      // }
      // if (isChecked && index === -1) {
      //   setSelectedData((oldData) => {
      //     if (oldData?.product) {
      //       oldData.product = oldData?.product?.concat(element);
      //     } else {
      //       oldData.product = element;
      //     }
      //     return oldData;
      //   });
      // } else if (!isChecked && index > -1) {
      //   setSelectedData((oldData) => {
      //     oldData.product = oldData?.product?.filter((el) => {
      //       return el.id !== element.id;
      //     });
      //     if (oldData?.product?.length === 0) {
      //       enableDisableApplyButton();
      //     }
      //     return oldData;
      //   });
      // }
    }
  };
  const clearSelection = () => {
    // setSelectedData(() => {
    //   return [];
    // });
    setSelectedData({
      product: [],
      country: [],
      mlrStatus: [],
      indication: []
    });
   // getSearchCriteria([], "Product");
    enableDisableApplyButton();
    // applySelection(undefined);
  };

  // return focus to the button when we transitioned from !open -> open
  const prevOpen = React.useRef(isOpen);
  useEffect(() => {
    if (prevOpen.current === true && isOpen === false) {
      if(title === 'Product') {
        setSelectedData({...selectedData, product: selectedFilterData});
      }
      if(title === 'Country') {
        setSelectedData({...selectedData, country: selectedFilterData});
      }
      setSearchText("");
      anchorRef.current.focus();
    }

    prevOpen.current = isOpen;
    enableDisableApplyButton();
  }, [isOpen]);

  const enableDisableApplyButton = () => {
    if (!isOpen) {
      toggleInitialLoad(true);
      return;
    }
    toggleInitialLoad(isOpen && (selectedFilterData || [])?.length === 0);
  };

  const applyButton = (
    <PrimaryButton
      title="Apply"
      handleClick={() => {
        getSearchCriteria(selectedData[title.toLowerCase()], title)
       // applySelection(selectedData);
        handleClose();
      }}
      disabled={(selectedData[title.toLowerCase()]?.length === 0 ) || initialLoad} //&& values?.brand.length === 0
      customClass={selectedData[title.toLowerCase()]?.length > 0 ?'activeApply':''}
    />
  );
  const clearButton = (
    <div
      //title="Clear"
      onClick={() => {
        clearSelection();
      }}
      className={selectedData[title.toLowerCase()]?.length > 0 ? "clearbtnEnable" : "clearbtnDisable"}
      disabled={!selectedData[title.toLowerCase()] || selectedData[title.toLowerCase()].length === 0}
    >Clear</div>
  );

  const getArrow = () => {
    if (isOpen) {
      return blueUpArrow;
    } else if (disabled) {
      return grayDownArrow;
    }
    return blueDownArrow;
  };

  useEffect(() => {
    setFilteredList(data);
  }, [data]);

  useEffect(() => {
    searchResults(searchText);
  }, [searchText]);
  
  const searchResults = (searchText) => {
    if (!data) {
      return;
    }
    let filterData = [...data];

    // Filter by Search Input
    if (searchText && searchText?.trim()) {
      searchText = searchText?.toLowerCase();
      filterData = filterData.filter((item) => {
        const listItem = item.name || item;
        return listItem.toLowerCase().includes(searchText)
      });
    }
    setFilteredList(filterData);
  };
  return (
    <div className={`filterContainer ${classes.root}`} style={{pointerEvents:searchExpand?'none':''}}>
      <div
        className={`btn multiselect-dropdown ${isOpen ? "active" : ""} ${
          disabled ? "disabled" : ""
          }`}
        
        ref={anchorRef}
        aria-controls={isOpen ? "menu-list-grow" : undefined}
        aria-haspopup="true"
        disabled={disabled}
        onClick={() => {
          if (disabled || searchExpand) {
            return;
          } else {
            handleToggle()
          }
           
        }}
      >
        {" "}
        {title}
        <img src={getArrow()} alt="" style={{ marginLeft: "4px", height:'6px', width:'9px' }} />
      </div>
      <Popper
        open={isOpen && !searchExpand}
        anchorEl={anchorRef.current}
        role={undefined}
        transition
        disablePortal
        className="multi-select-dropdown-outer"
        placement="bottom-end"
      >
        {/*  */}
        {({ TransitionProps }) => (
          <Grow {...TransitionProps}>
            <Paper className="paper-comp">
              <ClickAwayListener onClickAway={handleClose}>
                <div>
                  <MultiSelectList
                    data={filteredList}
                    anchorRef={anchorRef}
                    open={true}
                    handleSelection={handleSelection}
                    selected={selectedData}
                    height="200px"
                    searchResults={(value) => setSearchText(value)}
                    inputValue={searchText}
                    setIsSearchBarEmpty={setIsSearchBarEmpty}
                    multiple={multiple}
                    handleClose={handleClose}
                    title={title}
                  />
                  {multiple && <FooterButtons
                    primaryButton={applyButton}
                    secondaryButton={clearButton}
                    size="sm"
                  /> }
                </div>
              </ClickAwayListener>
            </Paper>
          </Grow>
        )}
      </Popper>
    </div>
  );
};

export default MultiselectDropDown;
